module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-agreement"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponAgreement.title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.cnt), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Views.CouponAgreement.btn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "confirm"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.agree,
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.handleAgree
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-016fe418!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/coupons/agreement.vue
// module id = 1077
// module chunks = 1